import { Box, Divider, ListItem, styled, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FrontApi } from '../../api/front-api/front.api'
import { Link, useLocation } from 'react-router-dom'
import clsx from 'clsx'
import SettingsPhoneIcon from '@mui/icons-material/SettingsPhone';
import EmailIcon from '@mui/icons-material/Email';
import { useSelector } from 'react-redux'
import { RootState } from '../../store/store'
import { content_icon } from '../../assets/icons/icons'
import { useTranslation } from 'react-i18next'
import { openGoogleMapByLatLng } from '../../utils/app.utils'
// import { getMenuData } from '../../constants/menu'

type Props = {}
const ContentTop = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down('md')]: {
        justifyContent: "center",
        gap: "3rem",
        padding: "0 2rem",
        flexDirection: "column"
    }
}))
const ContentBottom = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "3rem",
    [theme.breakpoints.down('md')]: {
        justifyContent: "center",
        gap: 4,
        flexDirection: "column"
    }
}))
const FooterWebsite: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const location = useLocation();
    const path_name = location.pathname;

    const base_url = useSelector((state: RootState) => state.api.image_api);

    const [footerData, setFooterData] = useState<any>(null);
    const [footer_social_media, set_footer_social_media] = useState<any[]>([]);
    const [contact_data, set_contact_data] = useState<{ lat: string, lng: string }>({ lat: "", lng: "" })

    // console.log(footerData,'footerData')
    // const menuData = getMenuData({ t });
    const [content_data, _set_content_data] = useState<{
        id: number;
        icon: string;
        key: string;
        link: string;
    }[]>([
        {
            id: 1,
            key: "FACEBOOK",
            icon: content_icon.facebookIcon,
            link: ""
        },
        {
            id: 2,
            key: "INSTAGRAM",
            icon: content_icon.igIcon,
            link: ""
        },
        {
            id: 3,
            key: "X",
            icon: content_icon.xIcon,
            link: ""
        },
        {
            id: 4,
            key: "YOUTUBE",
            icon: content_icon.youtubeIcon,
            link: ""
        },
        {
            id: 5,
            key: "LINE",
            icon: content_icon.lineIcon,
            link: ""
        },
    ])

    const handleGetFooterData = async () => {
        await FrontApi.footer().then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || null;
                const footer_social_media_value = response?.footer_social_media || [];
                set_footer_social_media(footer_social_media_value)
                setFooterData(response)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const handleGetContactData = async () => {
        await FrontApi.contact().then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || null;
                set_contact_data({ lat: response?.contact?.latitude || "", lng: response?.contact?.longitude || "" })
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const footer_menu: any[] = footerData?.footer_menu || [];

    useEffect(() => {
        handleGetFooterData();
        handleGetContactData();
    }, [])

    return (
        <Box className="w-full bg-[#FFF9F1] min-h-fit py-10 max-h-fit xl:min-h-[664px]">
            <Box className="w-full px-10 xl:px-0 max-w-[1336px] m-auto">
                <ContentTop>
                    <Box className="flex flex-col gap-[40px]">
                        <span>
                            <Typography fontWeight={700} fontSize={24}>
                                {t("HOME_PAGE_SYSTEM_MENU")}
                            </Typography>
                        </span>
                        <span className='grid grid-cols-12'>
                            {/* {menuData?.map((list) => {
                                return (
                                    <Link to={list?.disabled ? '#' : list?.url}
                                        onClick={(e) => {
                                            if (list?.disabled) e.preventDefault();
                                            window.scrollTo({ top: 0, behavior: "smooth" })
                                        }} className={clsx(
                                            'col-span-12 md:col-span-3',
                                            {
                                                'text-[#9E640E]': path_name === list?.url,
                                                'pointer-events-none opacity-50': list?.disabled,
                                            }
                                        )}>
                                        <ListItem>
                                            {list?.label}
                                        </ListItem>
                                    </Link>
                                )
                            })} */}
                            {footer_menu?.map((list) => {
                                return (
                                    <Link className={clsx('col-span-12 md:col-span-3', {
                                        'text-[#9E640E]': path_name === list?.menu_link
                                    })} target={list?.menu_status_open === 'current_tab' ? undefined : '_blank'} to={list?.menu_link}>
                                        <ListItem>
                                            {list?.menu_name || "-"}
                                        </ListItem>
                                    </Link>
                                )
                            })}
                        </span>
                    </Box>
                    <Box>
                        <Box className="flex flex-col gap-[40px]">
                            <span>
                                <Typography fontWeight={700} fontSize={24}>
                                    {t("HOME_PAGE_CONTACT_US")}
                                </Typography>
                            </span>
                            <span className='flex flex-col gap-4'>
                                <Typography><SettingsPhoneIcon /> {t("HOME_PAGE_TELEPHONE")} : {footerData?.footer_tel || "-"}</Typography>
                                <Typography><EmailIcon /> {t("HOME_PAGE_EMAIL")} : {footerData?.footer_contact_suggestions || "-"}</Typography>
                            </span>
                        </Box>
                    </Box>
                </ContentTop>
                <Divider sx={{ my: 5 }} />
                <ContentBottom>
                    <Box className="w-full max-w-fit">
                        <img width={290} height={115} src={`${base_url}/${footerData?.footer_file?.media_file_path}${footerData?.footer_file?.media_file_name}`} alt="base-rl" />
                    </Box>
                    <Box className="w-full flex-1 flex flex-col justify-center md:justify-start items-center gap-3 my-5 md:my-0 md:items-start md:gap-4">
                        <Typography fontWeight={700} textAlign={{ xs: "center", xl: "start" }} sx={{ fontSize: "32px", color: footerData?.footer_name_color ? footerData?.footer_name_color : "#4A4A4A" }}>
                            {footerData?.footer_name || "-"}
                        </Typography>
                        <Typography fontWeight={700} textAlign={{ xs: "center", xl: "left" }} sx={{ fontSize: "20px", color: footerData?.footer_sub_text_color ? footerData?.footer_sub_text_color : "#4A4A4A" }}>
                            {footerData?.footer_sub_text || "-"}
                        </Typography>
                        <Typography
                            className={clsx("", {
                                "cursor-pointer hover:underline": (contact_data?.lat && contact_data?.lng)
                            })}
                            onClick={() => (contact_data?.lat && contact_data?.lng) ? openGoogleMapByLatLng(+contact_data?.lat, +contact_data?.lng) : undefined}
                            textAlign={{ xs: "center", xl: "left" }} sx={{ color: footerData?.footer_desc_color ? footerData?.footer_desc_color : "#4A4A4A" }}>
                            {footerData?.footer_desc || "-"}
                        </Typography>
                    </Box>
                    <Box className="flex flex-wrap justify-end gap-2 items-center">
                        {content_data?.filter((x) => footer_social_media?.some((y) => y?.icon === x?.key)).map((list, i) => {
                            const link_url = footer_social_media?.find((x) => x?.icon == list?.key)?.social_media_link || ""
                            return (
                                <Link target='_blank' to={link_url}>
                                    <img src={list?.icon} alt={`_${i}`} />
                                </Link>
                            )
                        })}
                    </Box>
                </ContentBottom>
                <Box sx={{ my: "40px" }}>
                    <Typography textAlign={{ xs: "center", xl: "left" }}>{footerData?.footer_copyright || "-"}</Typography>
                </Box>
            </Box >
        </Box >
    )
}

export default FooterWebsite